import { useContext } from 'react';
import { AppContext } from '../containers/App/context';

function useSelectedProperty(): Object {
  const { selectedProperty } = useContext(AppContext) ?? {};
  return selectedProperty;
}

export default useSelectedProperty;
